export default {
  'home.title': 'หน้าแรก',
  'home.event': 'กิจกรรม',
  'home.news': 'ข่าวสาร',
  'home.event_information': 'รายละเอียดกิจกรรม',
  'home.announcement': 'ประกาศสำคัญ',
  'home.goto': 'ไปที่',
  'home.latest_events': 'กิจกรรมล่าสุด',
  'home.more_events': 'ดูกิจกรรมทั้งหมด',
  'home.empty': 'ขณะนี้ยังไม่มีเนื้อหา',
} as Record<string, string>;
